import { render, staticRenderFns } from "./DocumentationForm.vue?vue&type=template&id=588c8069&"
import script from "./DocumentationForm.vue?vue&type=script&lang=js&"
export * from "./DocumentationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports